import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { contextConnect, useContextSystem } from '@wp-g2/context';
import { cx } from '@wp-g2/styles';
import { pick } from 'lodash';
import React from 'react';
import * as baseButtonStyles from '../BaseButton/BaseButton.styles';
import { Heading } from '../Heading';
import * as styles from './Menu.styles';
var sizeStyles = pick(baseButtonStyles, ['large', 'small', 'xSmall']);
/**
 * @typedef OwnProps
 * @property {keyof sizeStyles} size
 */

/**
 * @typedef {import('../Heading/types').Props & OwnProps} Props
 */

/**
 *
 * @param {import('@wp-g2/create-styles').ViewOwnProps<Props, 'div'>} props
 * @param {import('react').Ref<any>} forwardedRef
 */

function MenuHeader(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'MenuHeader'),
      children = _useContextSystem.children,
      className = _useContextSystem.className,
      size = _useContextSystem.size,
      otherProps = _objectWithoutProperties(_useContextSystem, ["children", "className", "size"]);

  var classes = cx(styles.MenuHeader, sizeStyles[size], className);
  return /*#__PURE__*/React.createElement(Heading, Object.assign({
    size: 5
  }, otherProps, {
    className: classes,
    ref: forwardedRef
  }), children);
}

export default contextConnect(MenuHeader, 'MenuHeader');